import React, { useEffect, useState, useRef } from 'react';
import { Grid, Paper, List, ListItem, ListItemAvatar, Avatar, ListItemText, Divider, TextField, Fab, Dialog, DialogTitle, DialogContent } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import '../../../css/component/chat.css';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from '../Notification';
//import { formatDate } from 'src/utils/DateUtils';
import * as Stomp from '@stomp/stompjs';
import { REACT_APP_SOCKET_CONNECTION_URL } from 'src/utils/pnd/config';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import IconButton from '@mui/material/IconButton';


const Chat = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedContact, setSelectedContact] = useState(null);
    const [messages, setMessages] = useState([]);
    const [messageText, setMessageText] = useState('');
    const [contacts, setContacts] = useState([]);
    const [isChatId, setChatId] = useState(null);
    const [prevChatId, setPrevChatId] = useState(null);
    const messagesEndRef = useRef(null); // Ref for the last message element
    const [openLocation, setOpenLocation] = useState(false);
    const [location, setLocation] = useState({ lat: null, lng: null });

    let stompClient = null;
    let reconnectTimeout = null;

    useEffect(() => {
        getAllRidersDetails();
    }, []);

    useEffect(() => {
        const connect = async () => {
            if (!isChatId) return;

            const token = localStorage.getItem('access_token');
            if (!token) {
                console.log('No access token found in Chat, skipping WebSocket connection');
                return;
            }

            try {
                const socket = new WebSocket(REACT_APP_SOCKET_CONNECTION_URL);
                stompClient = Stomp.Stomp.over(socket);
                //console.log(stompClient);
                stompClient.connect({}, async () => {
                    //console.log('Connected to WebSocket in Chat Service');
                    // Unsubscribe from any existing subscriptions if there's a previous chatId
                    if (prevChatId && stompClient.subscriptions) {
                        stompClient.subscriptions.forEach(sub => sub.unsubscribe());
                    }

                    if (isChatId) {
                        console.log("Chat Id: ", isChatId);
                        setPrevChatId(isChatId);
                        stompClient.subscribe('/topic/chat/' + isChatId, (message) => {
                            const data = JSON.parse(message.body);
                            //console.log(data);
                            let newMessage = {
                                "createdAt": data?.message?.createdAtStr,
                                "message": data?.message?.message,
                                "userFullName": data?.message?.userFullName,
                            };
                            setMessages(prevMessages => [...prevMessages, newMessage]);
                        });
                    } else {
                        console.log('Invalid Chat Id:', isChatId);
                    }
                }, (error) => {
                    console.error('STOMP connection error:', error);
                });

                stompClient.onWebSocketClose = (closeEvent) => {
                   // console.error('WebSocket connection closed in Chat Service:', closeEvent);

                    // If the WebSocket is closed, call the API during reconnect time
                    if (isChatId === prevChatId) {
                        // alert('WebSocket connection closed. Attempting to reconnect...');
                        reconnectTimeout = setTimeout(async () => {
                            // Call the API during reconnect time
                            const receiverType = 6; // Rider
                            const response = await PndRestApi.GetAllChatHistoryByRiderId(selectedContact, receiverType);
                            console.log("SFSFSFS", response); // Log the response
                            if (response !== undefined) {
                                if (response.status === 200 && response.data.status === 200) {
                                    setMessages(response.data.data?.messages || []);
                                    setChatId(response.data?.data?.chat?.id);
                                    if (prevChatId === null) {
                                        setPrevChatId(response.data?.data?.chat?.id);
                                    }
                                }
                            }
                            // Attempt to reconnect
                            connect();
                        }, 1000); // Reconnect after 1 second
                    } else {
                        setPrevChatId(isChatId);
                    }
                };

                stompClient.onWebSocketError = (error) => {
                    console.error('WebSocket error in Chat Service:', error);
                };
            } catch (error) {
                console.error('Error establishing WebSocket connection in Chat Service:', error);
            }
        };

        connect();

        return () => {
            if (stompClient) {
                if (stompClient.subscriptions) {
                    stompClient.subscriptions.forEach(sub => sub.unsubscribe());
                }
                stompClient.disconnect();
            }
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
            }
        };
    }, [isChatId, prevChatId]);

    useEffect(() => {
        if (messagesEndRef && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    const getAllRidersDetails = async () => {
        try {
            const response = await PndRestApi.GetAllRidersDetails();
            if (response.status === 200 && response.data.status === 200) {
                const mappedContacts = response.data.data.map((item, index) => ({
                    id: item.riderId,
                    name: item.riderName,
                    avatarUrl: generateAvatarUrl(item.riderName),
                    status: "Online"
                }));
                setContacts(mappedContacts);
            }
        } catch (error) {
            console.error('Error fetching data:', error);

        }
    };

    const generateAvatarUrl = (firstName) => {
        // Basic example: generate initials-based avatar image
        const initials = firstName.substring(0, 2).toUpperCase(); // Get first initial
        const colors = ['#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#F44336']; // List of colors
        const randomColor = colors[Math.floor(Math.random() * colors.length)]; // Pick a random color
        const canvas = document.createElement('canvas');
        canvas.width = 48;
        canvas.height = 48;
        const context = canvas.getContext('2d');
        context.fillStyle = randomColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = '24px Arial';
        context.fillStyle = '#FFFFFF';
        context.textAlign = 'center';
        context.fillText(initials, 24, 32);
        return canvas.toDataURL(); // Return data URL of the canvas
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleContactClick = async (contactId) => {
        setSelectedContact(contactId);
        if (isChatId) {
            stompClient.disconnect();
        }
        const receiverType = 6; // Rider
        const response = await PndRestApi.GetAllChatHistoryByRiderId(contactId, receiverType);
        if (response.status === 200 && response.data.status === 200) {
            setMessages(response.data.data?.messages || []);
            setChatId(response.data?.data?.chat?.id);
            if (prevChatId === null) {
                setPrevChatId(response.data?.data?.chat?.id);
            }
        }
    };


    const handleSendMessage = async () => {
        if (!messageText.trim()) return; // Prevent sending empty messages
        const newMessage = {
            userId: localStorage.getItem("ui"),
            message: messageText,
            localcreatedAt: new Date().toLocaleTimeString(),
        };
        try {
            let Obj = {
                "chatType": 1, // Support
                "message": messageText,
                "receiverId": selectedContact,
                "receiverType": 6, // Rider
                "chatId": isChatId,
            };
            const response = await PndRestApi.saveChatData(Obj);
            if (response.status === 200 && response.data.status === 200) {
                // Handle success if needed
            }
        } catch (error) {

            showNotification(
                "theme-light",
                "ltr",
                `Message: Operation Failed due to some reason. Please try again`
            );
        }

        // Add new message to the beginning of the messages array
        setMessages(prevMessages => [...prevMessages, newMessage]);

        // Clear the message text field after sending
        setMessageText('');
    };

    const filteredContacts = contacts.filter(contact =>
        contact.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const getInitials = (name = '') => {
        if (!name) return '?';
        return name.substring(0, 2).toUpperCase();
    };

    const getAvatarColor = (name = '') => {
        const colors = ['#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#F44336'];
        return colors[name.length % colors.length];
    };

    return (
        <div>

            <Grid container component={Paper} className="chatSection">
                <Grid item xs={3} className="borderRight500">
                    <List>
                        <ListItem button key="Available Rider">
                            <ListItemAvatar>
                                <Avatar alt="Available Rider" src="https://material-ui.com/static/images/avatar/1.jpg" />
                            </ListItemAvatar>
                            <ListItemText primary="Available Rider" />
                        </ListItem>
                    </List>
                    <Divider />
                    <Grid item xs={12} style={{ padding: '10px' }}>
                        <TextField
                            id="outlined-basic-email"
                            label="Search"
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </Grid>
                    <Divider />
                    <List>
                        {filteredContacts.map(contact => (
                            <ListItem
                                button
                                key={contact.id}
                                onClick={() => handleContactClick(contact.id)}
                                selected={selectedContact === contact.id}
                            >
                                <ListItemAvatar>
                                    <Avatar alt={contact.name} src={contact.avatarUrl} />
                                </ListItemAvatar>
                                <ListItemText primary={contact.name} secondary={contact.status} align="left" />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={9}>
                    {selectedContact && (
                        <>
                            <List className="messageArea">
                                {messages && messages.map((message, index) => {
                                    const isMe = message.userId == localStorage.getItem('ui');

                                    return (
                                        <ListItem
                                            key={index}
                                            alignItems="flex-start"
                                            style={{ justifyContent: isMe ? 'flex-end' : 'flex-start' }}
                                        >
                                            {!isMe && (
                                                <ListItemAvatar>
                                                    <Avatar
                                                        sx={{
                                                            bgcolor: getAvatarColor(message.userFullName),
                                                            width: 30,
                                                            height: 30,
                                                            fontSize: 12
                                                        }}
                                                    >
                                                        {getInitials(message.userFullName)}
                                                    </Avatar>
                                                </ListItemAvatar>
                                            )}

                                            <ListItemText
                                                sx={{
                                                    maxWidth: '65%',
                                                    textAlign: isMe ? 'right' : 'left'
                                                }}
                                                primary={
                                                    <div
                                                        style={{
                                                            background: isMe ? '#DCF8C6' : '#FFFFFF',
                                                            padding: '8px 12px',
                                                            borderRadius: 10,
                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                                                            display: 'inline-block',
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {!isMe && message.userFullName && (
                                                            <div style={{ fontSize: 8, fontWeight: 500, marginBottom: 4 }}>
                                                                {message.userFullName}
                                                            </div>
                                                        )}

                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                            <span  style={{ fontSize: 12}}>{message.message}</span>

                                                            {message.latitude && message.longitude && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setLocation({
                                                                            lat: message.latitude,
                                                                            lng: message.longitude
                                                                        });
                                                                        setOpenLocation(true);
                                                                    }}
                                                                >
                                                                    <LocationOnIcon color="primary" fontSize="small" />
                                                                </IconButton>

                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                secondary={
                                                    <span style={{ fontSize: 8, color: '#888' }}>
                                                        {message?.createdAt
                                                            ? message.createdAt.replace('T', ' ').split('.')[0]
                                                            : message?.localcreatedAt}
                                                    </span>
                                                }
                                            />
                                        </ListItem>
                                    );
                                })}

                                <div ref={messagesEndRef} /> {/* Reference for scrolling */}
                            </List>
                            <Divider />
                            <div className="messageInputContainer">
                                <TextField
                                    id="outlined-basic-email"
                                    label="Message"
                                    fullWidth
                                    value={messageText}
                                    onChange={(e) => setMessageText(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSendMessage();
                                        }
                                    }}
                                />
                                <Fab color="success" aria-label="add" onClick={handleSendMessage}>
                                    <SendIcon />
                                </Fab>
                            </div>
                        </>
                    )}
                </Grid>
            </Grid>
            <Dialog
                open={openLocation}
                onClose={() => setOpenLocation(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    Rider Location
                    <IconButton
                        onClick={() => setOpenLocation(false)}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        ✕
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {location.lat && location.lng ? (
                        <iframe
                            title="Rider Location"
                            width="100%"
                            height="400"
                            style={{ border: 0 }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps?q=${location.lat},${location.lng}&z=15&output=embed`}
                        />
                    ) : (
                        <div>No location available</div>
                    )}
                </DialogContent>
            </Dialog>

        </div>
    );
};

export default Chat;